"use client";

import { BSRCart } from "./bsr/BSRCart";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { CartEmpty as LegacyCartEmpty } from "./legacy/CartEmpty";

export const CartEmpty = createBSRExperimentIcon(LegacyCartEmpty, BSRCart);
